(function($, undefined) {
	
	'use strict';
	var formCom;
	
	var init = function () {
		formCom = Fw.component.models().form;
		
		$('.toolkit-validate-form').click(function() {
			formCom.validateForm($('.toolkit-form'));
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
